// extracted by mini-css-extract-plugin
export var button = "_5x-0";
export var icon = "_5x-1";